/**
 * Skip to Content Component
 * 
 * This component provides a skip link for keyboard users to bypass navigation
 * and go directly to the main content. It's an important accessibility feature.
 * It follows the ConnectPath Modular Methodology, particularly Module M15 (Error Handling).
 */

import React from 'react';

interface SkipToContentProps {
  contentId?: string;
  label?: string;
}

export const SkipToContent: React.FC<SkipToContentProps> = ({
  contentId = 'main-content',
  label = 'Skip to main content'
}) => {
  return (
    <a
      href={`#${contentId}`}
      style={{
        position: 'absolute',
        top: '-40px',
        left: 0,
        padding: '8px 16px',
        background: '#2196f3',
        color: 'white',
        zIndex: 1000,
        transition: 'top 0.2s ease',
        textDecoration: 'none',
        fontWeight: 'bold'
      }}
      onFocus={(e) => {
        e.currentTarget.style.top = '0';
      }}
      onBlur={(e) => {
        e.currentTarget.style.top = '-40px';
      }}
    >
      {label}
    </a>
  );
};